// The payload is the deleted model's id, wrapped in an object: synapse's `DefaultPayload` requires
// `payload` to be a record (or an array of records), never a bare primitive.
export type AiModelDeletedPayload = {
	modelId: number;
};

export type AiModelDeletedAction = {
	type: 'AI_MODEL_DELETED';
	payload: AiModelDeletedPayload;
	accountId: number;
};

export default (payload: AiModelDeletedPayload, accountId: number): AiModelDeletedAction => ({
	type: 'AI_MODEL_DELETED',
	payload,
	accountId,
});
